import { EmptyEdgePropsSchema } from '../../graph-schemas/edges/common';
import type { EdgeDefinition } from './base-crm';

export const PEVC_PORTFOLIO_EDGES: Record<string, EdgeDefinition> = {
  INVESTMENT_IN: {
    type: 'INVESTMENT_IN',
    schema: EmptyEdgePropsSchema,
    displayName: 'Investment In',
    reverseDisplayName: 'Has Investment',
    sourceTypes: ['Investment'],
    targetTypes: ['Organization'], // Portfolio company (organization_type='portco')
    props: [],
  },
  FUND_INVESTMENT_IN: {
    type: 'FUND_INVESTMENT_IN',
    schema: EmptyEdgePropsSchema,
    displayName: 'Fund Investment In',
    reverseDisplayName: 'Has Fund Investment',
    sourceTypes: ['Investment'],
    targetTypes: ['ExternalFund'], // Investment in another fund
    props: [],
  },
  INVESTMENT_FROM: {
    type: 'INVESTMENT_FROM',
    schema: EmptyEdgePropsSchema,
    displayName: 'Investment From',
    reverseDisplayName: 'Made Investment',
    sourceTypes: ['Investment'],
    targetTypes: ['Vehicle'],
    props: [],
  },
  ORIGINATED_FROM: {
    type: 'ORIGINATED_FROM',
    schema: EmptyEdgePropsSchema,
    displayName: 'Originated From',
    reverseDisplayName: 'Led To',
    sourceTypes: ['Investment'],
    targetTypes: ['Deal'],
    props: [],
  },
  MANAGED_BY: {
    type: 'MANAGED_BY',
    schema: EmptyEdgePropsSchema,
    displayName: 'Managed By',
    reverseDisplayName: 'Manages',
    sourceTypes: ['ExternalFund'],
    targetTypes: ['Organization', 'Person'],
    props: [],
  },
  HAS_PORTFOLIO: {
    type: 'HAS_PORTFOLIO',
    schema: EmptyEdgePropsSchema,
    displayName: 'Has Portfolio',
    reverseDisplayName: 'Portfolio Of',
    sourceTypes: ['ExternalFund'],
    targetTypes: ['Organization'],
    props: [],
  },
};
